import { injectable } from "@launchtray/tsyringe-async";
import { DiceComboAction } from "./DiceComboAction";

@injectable()
export class GiftShieldsAction implements DiceComboAction {
    public readonly diceRollGiftRewardInShields: number;

    public constructor(diceRollGiftRewardInShields: number) {
        if (isNaN(diceRollGiftRewardInShields)) {
            throw new Error(`Failed to create GiftShieldsAction with diceRollGiftRewardInShields: ${diceRollGiftRewardInShields}.`);
        }
        this.diceRollGiftRewardInShields = diceRollGiftRewardInShields;
    }
}
